export function Link(data: any) {
  return (
    
    <>
    <span>Please find the article link:</span>{"  "}
      <a href={data?.record?.value} style={{"color":"#9ed4e9"}} target="_blank"> Click Here</a> 
    </>
  );
}